<template>
  <e-modal
    :visible="visible"
    :title="title"
    :width="900"
    :loading="loading"
    @close="onClose"
    @ok="onSubmit((e) => onSubmitFun(e))"
  >
    <a-spin tip="Loading..." :spinning="loading">
      <a-form>
        <e-input
          title="标题"
          :validate="validateInfos.title"
          v-model:value="modelRef.title"
        />

        <e-tree-select
          title="分类"
          :fieldNames="replaceFields"
          :validate="validateInfos.newsTypeId"
          v-model:value="modelRef.newsTypeId"
          :options="treeData"
        />

        <e-input-upload title="缩略图" v-model:value="modelRef.thumbnail" />

        <e-input title="标识" v-model:value="modelRef.sign" :valueCol="6" />
        <e-input-number title="点赞量" v-model:value="modelRef.like" :labelCol="4" />
        <e-input-number title="阅读次数" v-model:value="modelRef.readTimes" :labelCol="4" />

        <e-radio
          title="状态"
          v-model:value="modelRef.publishStatus"
          :options="$store.state.app.publishStatus"
        />

        <e-radio
          title="是否置顶"
          v-model:value="modelRef.isTop"
          :options="$store.state.app.isTop"
        />

        <e-switch
          title="主页显示"
          v-model:value="modelRef.isHomeShow"
        />

        <e-date-time
          title="发布时间"
          :showTime="true"
          v-model:value="modelRef.publishTime"
          :valueCol="6"
        />

        <e-textarea
          title="简介"
          v-model:value="modelRef.brief"
        />

        <e-editor ref="editor" title="内容" :validate="validateInfos.content" v-model:value="modelRef.content" />

      </a-form>
    </a-spin>
  </e-modal>
</template>

<script>
import { defineComponent, ref, reactive, toRaw } from 'vue'
import { Form } from 'ant-design-vue'
import form from '@/mixins/form'
import { NewsClass } from '@/apis/news'
import { dataToTree } from '@/utils'
import dayjs from 'dayjs'

const useForm = Form.useForm
const api = new NewsClass()
export default defineComponent({
  components: {

  },
  mixins: [form],
  emits: ['ok'],
  setup (props, { emit }) {
    const loading = ref(false)
    const visible = ref(false)
    const isEdit = ref(false)
    const title = ref('')

    const modelRef = reactive(api.modelRef)
    const rulesRef = reactive(api.rulesRef)

    const { resetFields, validate, validateInfos } = useForm(
      modelRef,
      rulesRef
    )

    const onClose = () => {
      resetFields()
      loading.value = false
      visible.value = false
    }

    const replaceFields = {
      label: 'name',
      value: 'id'
    }
    const treeData = ref([])

    return {
      title,
      visible,
      loading,
      isEdit,
      modelRef,
      validateInfos,
      replaceFields,
      treeData,
      resetFields,
      validate,
      onClose
    }
  },

  methods: {
    open (formData) {
      if (formData) {
        this.modelRef.title = formData.title
        this.modelRef.sign = formData.sign
        this.modelRef.content = formData.content
        this.modelRef.brief = formData.brief
        this.modelRef.thumbnail = formData.thumbnail
        this.modelRef.publishTime = dayjs(formData.publishTime)
        this.modelRef.publishStatus = formData.publishStatus
        this.modelRef.newsTypeId = formData.newsTypeId
        this.modelRef.isHomeShow = formData.isHomeShow
        this.modelRef.isTop = formData.isTop
        this.modelRef.readTimes = formData.readTimes
        this.modelRef.like = formData.like
        this.modelRef.id = formData.id

        this.$refs.editor.setHtml(formData.content)

        this.title = '编辑：' + formData.title
        this.isEdit = true
      } else {
        this.modelRef = reactive(api.modelRef)

        this.modelRef.publishTime = dayjs()
        this.title = '添加文章'

        this.$refs.editor.setHtml('')
        this.isEdit = false
      }

      this.getNewsTypes()
      this.visible = true
    },

    async getNewsTypes () {
      const list =
        this.$store.state.data.ALL_NEWTYPES.length > 0
          ? this.$store.state.data.ALL_NEWTYPES
          : await this.$store.dispatch('GetAllNewsTypes')

      const data = dataToTree(list, 0)
      this.treeData = data
    },

    onSubmitFun (e) {
      const data = toRaw(e)

      if (this.isEdit) {
        api.update(data).then(() => {
          this.loading = false
          this.$message.success('编辑成功')
          this.$emit('ok', data)
          this.onClose()
        })
      } else {
        delete data.id
        api.create(data).then(() => {
          this.loading = false
          this.$message.success('添加成功')
          this.$emit('ok', data)
          this.onClose()
        })
      }
    }
  }
})
</script>
